import { forwardRef } from 'react';
import clsx from 'clsx';
import { Info } from '@gjensidige/builders-icons';
import styles from './tip.module.less';

export type TipProps = React.ComponentPropsWithRef<'div'> & {
  icon?: boolean;
};

export const Tip = forwardRef<HTMLDivElement, TipProps>(function Tip(
  { children, className, icon = true, ...rest },
  ref
) {
  return (
    <div {...rest} className={clsx(styles.tip, className)} ref={ref}>
      {!!icon && <Info />}
      <div>{children}</div>
    </div>
  );
});
